<template>
  <div>
    <h2>
      {{ product.payload.product }}
      <font-awesome-icon class="text-primary" :icon="['far', 'tachometer-fast']" :style="iconStyle"></font-awesome-icon>
    </h2>
    <p class="subheading">{{ product.payload.message[0] }}</p>
    <div class="vehicle-info">
      <div class="row">
        <div class="col left">
          <p class="description">
            {{
              $t(
                `message.spotlightV2.categories.highlights.${enums.SpotlightConstants.internalNames.autoverify['LOW-MILEAGE']}.thisVehicle`
              )
            }}
          </p>
          <p class="stat-vehicle">
            {{ $n(product.payload.data.vehicleMileage, 'number', getLanguageCodeForNumericalInternationalization) }}
            {{
              $t(
                `message.spotlightV2.categories.highlights.${enums.SpotlightConstants.internalNames.autoverify['LOW-MILEAGE']}.km`
              )
            }}
          </p>
        </div>
        <div class="col right">
          <p class="description">
            {{
              $t(
                `message.spotlightV2.categories.highlights.${enums.SpotlightConstants.internalNames.autoverify['LOW-MILEAGE']}.nationalAverage`
              )
            }}
          </p>
          <p class="stat-average">
            {{ $n(product.payload.data.nationalAverage, 'number', getLanguageCodeForNumericalInternationalization) }}
            {{
              $t(
                `message.spotlightV2.categories.highlights.${enums.SpotlightConstants.internalNames.autoverify['LOW-MILEAGE']}.km`
              )
            }}
          </p>
        </div>
      </div>
    </div>
    <p class="details-pill text-center mt-4">
      {{
        $t(
          `message.spotlightV2.categories.highlights.${enums.SpotlightConstants.internalNames.autoverify['LOW-MILEAGE']}.averageMileage`,
          {
            mileage: $n(
              product.payload.data.expectedAnnualMileage,
              'number',
              getLanguageCodeForNumericalInternationalization
            ),
          }
        )
      }}
    </p>
    <hr />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'LowMileage',
  props: {
    product: {
      validator: prop => typeof prop === 'object' || prop === undefined,
      required: true,
    },
  },
  data() {
    return {
      iconStyle: {
        marginLeft: '8px',
        fontSize: '18px',
      },
    };
  },
  computed: {
    ...mapGetters('user', ['getLanguageCodeForNumericalInternationalization']),
    highlightsProductDataMap() {
      return {
        [this.enums.SpotlightConstants.internalNames.autoverify['LOW-MILEAGE']]: {
          icon: 'tachometer-slow',
        },
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import 'src/assets/scss/variables';

hr {
  color: rgb(218, 226, 234);
  margin-top: 40px;
}
.subheading {
  font-size: 16px;
}
.vehicle-info {
  border-radius: 5px;
  border: 1px solid rgb(218, 226, 234);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.06);
  padding: 22px;
  .left {
    border-right: 0.25px solid rgb(218, 226, 234);
  }
  .description {
    color: rgb(109, 119, 131);
    font-size: 14px;
    margin-top: 0;
    margin-bottom: 0;
  }
  .stat-vehicle {
    color: $primary;
    font-size: 22px;
    font-weight: bold;
  }
  .stat-average {
    color: rgb(25, 34, 43);
    font-size: 22px;
    font-weight: bold;
  }
  .stat-vehicle,
  .stat-average {
    margin-bottom: 0;
  }
}
.details-pill {
  background: $primary-light-background2;
  border-radius: 24px;
  color: $primary-dark;
  font-size: 14px;
  padding: 4px;
}

@media only screen and (min-width: 576px) {
  .left,
  .right {
    padding-left: 40px;
  }
  .details-pill {
    padding: 8px;
    margin-bottom: 40px;
  }
  .subheading {
    margin-bottom: 40px;
  }
  .vehicle-info {
    padding: 32px 20px;
    .stat-vehicle {
      font-size: 28px;
    }
    .stat-average {
      font-size: 28px;
    }
  }
}
</style>
